import type { ListWidget as ListWidgetSpec, PageRow } from '@developerz/domain';
import { For, type JSX, Show } from 'solid-js';
import { t } from '../../i18n';
import { formatCell } from '../../lib/widget-format';

// `list` presenter (arc 101 slice 09) — a feed/inbox: a bold primary line per row
// plus an optional muted secondary. Reads `primary_key` / `secondary_key` off each
// result row.
export function ListWidget(props: { spec: ListWidgetSpec; rows: readonly PageRow[] }): JSX.Element {
  return (
    <Show when={props.rows.length > 0} fallback={<p class="widget__empty">{t('widgets.empty')}</p>}>
      <ul class="widget-list">
        <For each={props.rows}>
          {(row) => (
            <li class="widget-list__row">
              <span class="widget-list__primary">{formatCell(row[props.spec.primary_key])}</span>
              <Show when={props.spec.secondary_key}>
                {(key) => <span class="widget-list__secondary">{formatCell(row[key()])}</span>}
              </Show>
            </li>
          )}
        </For>
      </ul>
    </Show>
  );
}
